import { ref, computed } from "vue";
const forms = ref({});
const veeValidateForms = ref({});
function useForm(formName) {
  return {
    form: computed(() => forms.value[formName] || {}),
    /* VeeValidate Functions */
    resetForm: () => veeValidateForms.value[formName]?.resetForm(),
    setTouched: () => veeValidateForms.value[formName]?.setTouched(),
    setFieldTouched: (field, isTouched) => veeValidateForms.value[formName]?.setFieldTouched(field, isTouched),
    setValues: (fields) => veeValidateForms.value[formName]?.setValues(fields),
    setErrors: (fields) => veeValidateForms.value[formName]?.setErrors(fields),
    setFieldError: (field) => veeValidateForms.value[formName]?.setFieldError(field),
    setFieldValue: (field, value) => veeValidateForms.value[formName]?.setFieldValue(field, value)
  };
}
function defineForm(formName, value = {}) {
  if (!forms.value[formName]) {
    const reactiveForm = ref(value);
    forms.value = {
      ...forms.value,
      [formName]: reactiveForm
    };
  }
  return forms.value[formName];
}
function setVeeValidateForm(formName, veeValidate) {
  veeValidateForms.value = {
    ...veeValidateForms,
    [formName]: veeValidate
  };
}
export { defineForm, forms, useForm, setVeeValidateForm };
